
import React from 'react';
import { Icons } from '../ui/Icons';

const LoadingSpinner: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
    return (
        <div className="fixed inset-0 bg-white bg-opacity-75 dark:bg-slate-900 dark:bg-opacity-75 flex flex-col items-center justify-center z-50">
            <div className="relative">
                <img src="/icon.svg" alt="Loading" className="h-16 w-16 animate-pulse" referrerPolicy="no-referrer" />
                <div className="absolute inset-0 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin opacity-20"></div>
            </div>
            <p className="mt-4 text-lg font-medium text-gray-700 dark:text-gray-300">{message}</p>
        </div>
    );
};

export default LoadingSpinner;